import { useCallback, useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import api from "../lib/api";
import { confirmedReleaseIds, productErrorMessage } from "../lib/product";

// What each product runs now (`GET /product/versions/current`, lot 29 V4), shared by the cards, the list and the release page so a
// release is « confirmed » by the same reading everywhere.
export default function useRunningVersions() {
  const [products, setProducts] = useState(null);
  const [phase, setPhase] = useState("loading");
  const [refreshing, setRefreshing] = useState(false);
  const seq = useRef(0);
  const loaded = useRef(false);

  const reload = useCallback(async (refresh = false) => {
    const mine = ++seq.current;
    if (refresh) setRefreshing(true);
    try {
      const { data } = await api.get("/product/versions/current", { params: refresh ? { refresh: true } : {} });
      if (mine !== seq.current) return;
      loaded.current = true;
      setProducts(data.products);
      setPhase("ready");
    } catch (e) {
      if (mine !== seq.current) return;
      if (!loaded.current) setPhase("error");
      else toast.error(productErrorMessage(e, "Impossible d'actualiser les versions."));
    } finally {
      if (mine === seq.current) setRefreshing(false);
    }
  }, []);
  useEffect(() => { reload(); return () => { seq.current += 1; }; }, [reload]);

  return { products, phase, refreshing, reload, confirmedIds: confirmedReleaseIds(products) };
}
